export const formatEuro = (value) =>
    new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value ?? 0);

export const formatDate = (value) => {
    if (!value) {
        return '';
    }
    const normalizedValue = typeof value === 'string' ? value.trim() : value;

    if (typeof normalizedValue === 'string') {
        const match = normalizedValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (match) {
            const [, year, month, day] = match;
            const dateOnly = new Date(Number(year), Number(month) - 1, Number(day));
            if (!Number.isNaN(dateOnly.getTime())) {
                return dateOnly.toLocaleDateString('de-DE');
            }
        }
    }

    const date = new Date(normalizedValue);
    if (Number.isNaN(date.getTime())) {
        return String(value);
    }
    return date.toLocaleDateString('de-DE');
};

export const toNumber = (value) => {
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        return Number(value.replace(',', '.')) || 0;
    }
    return 0;
};

export const colorForRate = (rateLabel) => {
    const label = String(rateLabel);
    if (label.startsWith('19')) return 'rgba(255, 152, 0, 0.08)';
    if (label.startsWith('7')) return 'rgba(33, 150, 243, 0.08)';
    if (label.startsWith('0')) return 'rgba(76, 175, 80, 0.08)';
    return 'transparent';
};
